const TWINKL_URL = "https://www.twinkl.co.uk" as const;

const BASE_WEB_APP_PATH = "/curriculum-architect" as const;

const HOME_PATH = "/" as const;

const CURRICULUM_LIST_PATH = "/" as const;

const CURRICULUM_SUBJECT_LIST_PATH = "/curriculum/:curriculum_id/" as const;

const SUBJECT_PLAN_PATH =
  "/curriculum/:curriculum_id/subject/:subject_id" as const;

const SUBJECT_PLAN_EDIT_PATH = `${SUBJECT_PLAN_PATH}/edit` as const;
const SUBJECT_PLAN_OVERVIEW_PATH = `${SUBJECT_PLAN_PATH}/overview` as const;

const SCHEME_PATH = `${SUBJECT_PLAN_PATH}/scheme/:scheme_id/:cell_id` as const;

const SCHEME_PATH_SUPPORTING_MATERIALS =
  `${SCHEME_PATH}/supporting-materials` as const;
const SCHEME_LEARNING_SEQUENCE_PATH =
  `${SCHEME_PATH}/learning-sequence` as const;

const EXPLORE_SCHEME_LIST_CONTENTS_PATH = "/explore" as const;
const EXPLORE_SUBJECT_CONTENTS_SCHEME_PATH =
  "/explore/subject/:subject_id/scheme" as const;

const CURRICULUM_GOAL_PATH = "/goals" as const;

const ERROR_PATH = "/something-went-wrong" as const;

const external = {
  TWINKL_URL,
  TWINKL_LOGIN_URL: () => {
    const url = new URL(`${TWINKL_URL}/sign-in`);
    if (import.meta.env.VITE_ENABLE_LOGIN_RETURN_PARAM) {
      const queryParams = new URLSearchParams({
        redirect_uri: window.location.href,
      });
      url.search = queryParams.toString();
    }
    return url.toString();
  },
  TWINKL_PLANIT:
    "https://www.twinkl.co.uk/resources/planit-primary-teaching-resources" as const,
  TWINK_CA_LANDING: "https://www.twinkl.co.uk/curriculum-architect" as const,
  CUSTOMER_SUPPORT_URL: "https://www.twinkl.co.uk/contact-us" as const,
  FAQ_URL:
    "https://twinkl.zendesk.com/hc/en-gb/articles/25116211387293-Curriculum-Architect" as const,
  FEEDBACK_SURVEY_URL:
    "https://response.questback.com/dynamic/twinkl_ltd/mhcp1axjuk/answer?sid=T0HDhR8JXy" as const,
};

export const paths = {
  BASE_WEB_APP_PATH,
  HOME_PATH,

  EXPLORE_SCHEME_LIST_CONTENTS_PATH,

  EXPLORE_SUBJECT_CONTENTS_SCHEME_PATH,

  CURRICULUM_GOAL_PATH,

  CURRICULUM_LIST_PATH,
  CURRICULUM_SUBJECT_LIST_PATH,

  SUBJECT_PLAN_PATH,
  SUBJECT_PLAN_EDIT_PATH,
  SUBJECT_PLAN_OVERVIEW_PATH,

  SCHEME_PATH,

  SCHEME_PATH_SUPPORTING_MATERIALS,
  SCHEME_LEARNING_SEQUENCE_PATH,

  ERROR_PATH,

  external,
} as const;
